import React from "react";

function PayFailurePage() {
  return (
    <>
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>Payment Failed</h1>
        <p>Oops! It seems there was an issue processing your payment.</p>
        <p>Please check your payment details and try again.</p>
        <button
          style={{
            cursor: "pointer",
            padding: "20px",
            borderRadius: "20px",
            border: "1px solid black",
          }}
          onClick={() => {
            window.location.href = "/pricing";
          }}
        >
          Go to Pricing Section
        </button>
      </div>
    </>
  );
}

export default PayFailurePage;
